var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-alert",class:[`v-alert--${_vm.type}`]},[(_vm.icon)?_c('span',{staticClass:"v-alert-icon"},[_c('i',{class:_vm.icon})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"v-alert-title"},[_vm._t("default",function(){return [_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }